export default "/_next/static/images/d554c5e0f7b7cabb8a1e98925222883b.png";